import { IColumnHeader } from '../../../../store/mst/Upload/models';

// TODO: Replace with a more robust time parser using Luxon
// Function to normalize time strings. For example, 12:00 AM PST will be normalized to 12:00 AM and 20:00 PM will be normalized to 20:00
export function normalizeTime(timeString: string | undefined) {
  if (!timeString) {
    return timeString;
  }

  const matched12Hour = timeString.match(/^(\d{1,2}:\d{2})\s*[AP]M\s+([A-Z]{2,5})$/i);
  const matched24Hour = timeString.match(/^(\d{1,2}:\d{2})\s*[AP]M$/i);

  if (matched12Hour) {
    return matched12Hour[1].trim();
  }
  if (matched24Hour) {
    return matched24Hour[1].trim();
  }
  return timeString;
}

const applyColumnHeader = async (headerIndex: number, currentHeaderIdx: number, headers: IColumnHeader[]) => {
  // ignore columns that are not mapped
  if (headers[headerIndex]) {
    headers[headerIndex].mapToIndex(currentHeaderIdx);
  }
};

export const haveDuplicatesHeaders = (uploadHeaders: string[], uploadHeader: string) => {
  const count = uploadHeaders.filter((header) => header === uploadHeader);
  return count.length > 1;
};

export const getMatchingHeaderNameAndIndex = (mapping: any, uploadHeader: string, uploadHeaderIdx: number) => {
  return Object.keys(mapping).find(key => mapping[key][uploadHeader] === uploadHeaderIdx);
};

export const getMatchingHeaderName = (mapping: any, uploadHeader: string) => {
  for (const key of Object.keys(mapping)) {
    if (Object.keys(mapping[key]).includes(uploadHeader) && mapping[key][uploadHeader] != '-1') {
      return key;
    }
  }
  return undefined;
};

export const getMatchedColumns = (currentUploadHeaders: string[], mapping: any) => {
  return currentUploadHeaders.filter((uploadHeader: string, uploadHeaderIdx: number) =>
    getMatchingHeaderNameAndIndex(mapping, uploadHeader, uploadHeaderIdx),
  );
};

export const getUnmatchedColumns = (currentUploadHeaders: string[], matchedColumns: string[]) => {
  return currentUploadHeaders.filter((uploadHeader: string) =>
    !matchedColumns.includes(uploadHeader),
  );
};

export const processMatchedColumns = (matchedColumns: string[], currentUploadHeaders: string[], mapping: any, headers: IColumnHeader[]) => {
  matchedColumns.forEach((uploadHeader: string) => {
    const headerName = getMatchingHeaderNameAndIndex(mapping, uploadHeader, currentUploadHeaders.indexOf(uploadHeader));
    const headerIndex = headers.findIndex((h: any) => h.columnKey === headerName);
    applyColumnHeader(headerIndex, mapping[headerName!][uploadHeader], headers);
  });
};

export const processUnmatchedColumns = (unmatchedColumns: string[], currentUploadHeaders: string[], mapping: any, headers: IColumnHeader[]) => {
  unmatchedColumns.forEach((column: string) => {
    const isDuplicate = haveDuplicatesHeaders(currentUploadHeaders, column);
    // matchingHeaderName matches a name in the mapping but does not have the same column index
    // existing name in the mapping will take priority even if index is not the same
    const matchingHeaderName = getMatchingHeaderName(mapping, column);
    if (matchingHeaderName) {
      const headerIdx = headers.findIndex((h: any) => h.columnKey === matchingHeaderName);
      applyColumnHeader(headerIdx, currentUploadHeaders.indexOf(column), headers);
    } else {
      // Apply defaults if header does not exist in mapping
      // do not apply if it's a duplicate header
      // Iterate over each header in the sheet (currentUploadHeaders),
      // comparing with default headers (headers) and their list of matchKeys
      headers.forEach((header: IColumnHeader, configHeaderIdx: number) => {
        const matchKeys = header.matchKeys;
        const unmatchedHeader = header.matchedIndex == -1;
        if (matchKeys.includes(column) && !isDuplicate && unmatchedHeader) {
          applyColumnHeader(configHeaderIdx, currentUploadHeaders.indexOf(column), headers);
        }
      });
    }
  });
};

